// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OaS9t","select":"styles_select__2w4d-"};